export const isEmpty = object => {
  if (object == null) {
    return true;
  }
  if (typeof object === 'object') {
    return !Object.keys(object).length;
  }
  return true;
};